// Integração com o app nativo (Capacitor). No navegador tudo aqui vira no-op:
// o mesmo build serve o site e o app.

import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

export const ehNativo = Capacitor.isNativePlatform();
export const plataforma = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

// Barra de status com o texto na cor que contrasta com o tema do painel.
export async function sincronizarBarraDeStatus(escuro: boolean) {
  if (!ehNativo) return;
  try {
    await StatusBar.setStyle({ style: escuro ? Style.Dark : Style.Light });
    if (plataforma === 'android') {
      // Conteúdo por baixo da barra (o safe-area do CSS cuida do espaço).
      await StatusBar.setOverlaysWebView({ overlay: true });
    }
  } catch {
    // plugin indisponível: segue sem
  }
}

let iniciado = false;

// Chamado uma vez quando o app sobe.
export async function iniciarNativo() {
  if (!ehNativo || iniciado) return;
  iniciado = true;
  document.documentElement.classList.add('nativo', `nativo-${plataforma}`);

  // Botão voltar do Android: volta no histórico; na primeira tela, minimiza
  // (sair do app de uma vez com um toque acidental irrita).
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack && window.history.length > 1) window.history.back();
    else void App.minimizeApp();
  });

  await sincronizarBarraDeStatus(document.documentElement.classList.contains('dark'));
  // A tela já desenhou: esconde o splash.
  requestAnimationFrame(() => {
    void SplashScreen.hide({ fadeOutDuration: 200 });
  });
}
